// extracted by mini-css-extract-plugin
export default {"toastContainer":"styles_toastContainer__B4uGa","customSnackbarWrapper":"styles_customSnackbarWrapper__9dHAX"};